import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { LinkedInEvent } from "../types";

async function getUserEventsRequest(
  workspaceId: string,
  accountId: string,
): Promise<LinkedInEvent[]> {
  return (await get(`workspaces/${workspaceId}/accounts/${accountId}/events`))
    .events;
}

export default function useLinkedInEvents(accountId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const { data: linkedInEvents, isLoading: isLoadingLinkedInEvents } = useQuery(
    {
      queryKey: leadListSourcesKeys.linkedInEvents(accountId),
      queryFn: () => getUserEventsRequest(workspaceId, accountId),
      enabled: !!accountId,
    },
  );

  return {
    linkedInEvents,
    isLoadingLinkedInEvents,
  };
}
